module.exports = {"621002001":"北街","621002002":"南街","621002003":"西街","621002100":"肖金镇","621002101":"董志镇","621002102":"后官寨镇","621002103":"彭原镇","621002104":"温泉镇","621002203":"什社乡","621002204":"显胜乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621002.json
// module id = 2939
// module chunks = 0